import { Injectable } from '@angular/core';

export interface DetailsTreeNode {
    name?: string;
    value?: string;
    $$price?: number;
    $$children?: DetailsTreeNode[];
    $$editable?: 'description' | 'attachments' | null;
}

export type TranslateTreeFunc = (phrase: string, vars?: any) => string;

@Injectable({
    providedIn: 'root',
})
export class ConfigurationDetailsTreeService {
    constructor() {}

    static createRoot(): DetailsTreeNode {
        return {
            $$children: [],
        };
    }

    static createNode(
        name: string,
        value: string | null,
        price: number | null = 0,
        children: DetailsTreeNode[] = [],
        editable: 'description' | 'attachments' | null = null
    ): DetailsTreeNode {
        return {
            name,
            value,
            $$price: price,
            $$children: children,
            $$editable: editable,
        };
    }

    static pushChild(
        tree: DetailsTreeNode,
        name: string,
        value: string | null,
        price: number | null = 0,
        children: DetailsTreeNode[] = [],
        editable: 'description' | 'attachments' | null = null
    ) {
        const node = ConfigurationDetailsTreeService.createNode(
            name,
            value,
            price,
            children,
            editable
        );
        tree.$$children.push(node);
        return node;
    }
}
